/**
 * Auth layer — host-agnostic.
 *
 * Bu fayl barcha host-specific logikani `src/hosts/` registry ga delegate qiladi.
 * Yangi super app qo'shilganda bu fayl ga teginish kerak emas — yangi host
 * adapter qo'shsangiz `ensureAuthenticated()` o'z-o'zidan to'g'ri login ni chaqiradi.
 */

import { getToken, isTokenValid } from "@/lib/auth";
import {
  resolveActiveHost,
  NotTelegramEnvironmentError,
} from "@/hosts";
import type { LoginResponse } from "@/hosts";

export { NotTelegramEnvironmentError };
export type { LoginResponse };

/**
 * App boot vaqtida bir marta chaqiriladi. Token hali valid bo'lsa qayta
 * login qilinmaydi; aks holda aktiv host ning login flow i ishga tushadi.
 */
export async function ensureAuthenticated(): Promise<void> {
  if (isTokenValid(getToken())) return;
  const host = await resolveActiveHost();
  await host.login();
}
